<template>
  <div class="inputs">
    <div ref="input" class="input" :class="{ full: input.full_width }">
      <label class="optionalPosition">{{ input.label }}</label>
      <vue-google-autocomplete
        ref="autocomplete"
        id="input_address"
        class="md-layout-item md-size-100"
        placeholder="Address 1"
        v-model="test"
        v-on:placechanged="saveAddress"
        v-on:error="handleError"
      ></vue-google-autocomplete>
    </div>

    <div class="input">
      <label>
        Address 2
        <p class="optional">(optional)</p>
      </label>
      <input v-model="address.address_2" type="text" />
    </div>
    <div class="input">
      <label>Zip</label>
      <input v-model="address.zip" type="text" />
    </div>
    <div class="input">
      <label>City</label>
      <input v-model="address.city" type="text" />
    </div>
    <div class="input">
      <label>State</label>
      <input v-model="address.state" type="text" />
    </div>
  </div>
</template>

<script
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAhumEs_cAeJngaTPxtCYpXWuYMpc5fNPg&libraries=places&callback=initAutocomplete"
  async
  defer
></script>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "Address",
  props: ["input", "questionIndex", "answerKey"],
  components: {
    VueGoogleAutocomplete
  },

  data() {
    return {
      answer: null,
      test: "",
      address: {
        address_1: "",
        address_2: "",
        zip: "",
        city: "",
        state: ""
      }
    };
  },
  mounted() {},
  created() {
    if (this.input.value != "") {
      this.address = this.input.value;
    }
  },
  firestore() {
    return {};
  },
  methods: {
    saveAddress(input, obj) {
      if (input.street_number && !input.route) {
        this.address.address_1 = input.street_number;
      } else if (!input.street_number && input.route) {
        this.address.address_1 = input.route;
      } else if (!input.street_number && !input.route) {
        this.address.address_1 = "";
      } else {
        this.address.address_1 = input.street_number + " " + input.route;
      }
      if (this.address.address_1 == "") {
        if (document.getElementById("input_address").value) {
          this.address.address_1 = document.getElementById(
            "input_address"
          ).value;
        }
      }
      document.getElementById("input_address").value = this.address.address_1;

      this.address.city = input.locality;
      this.address.state = input.administrative_area_level_1;
      this.address.zip = input.postal_code;

      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.address
      );
    },
    handleError() {
      alert("error");
    }
  },
  watch: {}
};
</script>

<style scoped lang="scss">
</style>
